import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select } from "@mui/material";
import { Search as IconSearch } from "@mui/icons-material";
import * as terapiaService from "../../services/terapiaService";
import * as periodoService from "../../services/periodoService";
import * as personaService from "../../services/personaService";
import { obtenerPerfil } from "../../services/usuarioService";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { setValue, setNombreTerapeuta, setResults, setListPeriodos, setListTiposTerapias, setListEstados } from '../../redux/sessionTherapistSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import moment from "moment";

const IndexTherapist = () => {
    const params = useParams();
    const filters = useSelector((state) => state.sessionTherapistSearch.filters);
    const nombreTerapeuta = useSelector((state) => state.sessionTherapistSearch.nombreTerapeuta);
    const listPeriodos = useSelector((state) => state.sessionTherapistSearch.listPeriodos);
    const accesos = useSelector((state) => state.seguridad?.accesos || []);
    // const listTiposTerapias = useSelector((state) => state.sessionTherapistSearch.listTiposTerapias);
    // const listEstados = useSelector((state) => state.sessionTherapistSearch.listEstados);
    
    // const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    // const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    // Terapeuta dueño de las sesiones: sale de la ruta cuando se abre
    // por un id concreto y, si no, del usuario logueado.
    const [idTerapeuta, setIdTerapeuta] = useState(0);
    const [esTerapeuta, setEsTerapeuta] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();

    const fetchResults = async (idTerapeuta) => {
        setCargando(true);

        await terapiaService.getsTerapiaPeriodoResumenView({
                idPeriodo: filters.idPeriodo,
                idTipoTerapia: 0,
                participante: filters.participante,
                idTerapeuta: idTerapeuta,
                terapeuta: "",
                idEstado: 2,
            })
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    // El terapeuta de esta pantalla es el usuario logueado. Solo los usuarios
    // con persona de tipo terapeuta (idTipoPersona=25) deben ver sus terapias.
    // Si el usuario no es terapeuta (ej. ADMIN con idPersona=0), no se lista nada.
    const resolverIdTerapeuta = async () => {
        const idDeLaRuta = parseInt(params.id || "0");
        let id = idDeLaRuta;
        let nombres = "";
        let terapeuta = false;

        if (id <= 0) {
            const perfil = await obtenerPerfil().catch(() => null);
            id = perfil?.idPersona || 0;
            nombres = perfil?.nombres || "";
        }

        // La persona tiene que ser terapeuta (idTipoPersona = 25 o tener permisos de terapeuta)
        if (id > 0) {
            const pn = await personaService.getPersonaResumenBasicoById(id).catch(() => null);
            terapeuta = pn === 25 || accesos.includes("sesionTerapeuta.ver") || accesos.includes("terapiaPlanTerapeuta.ver");
        }

        setIdTerapeuta(id);
        setEsTerapeuta(terapeuta);

        if (!nombres && id > 0) {
            const persona = await personaService.getPersonaById(id).catch(() => null);
            nombres = persona?.nombres || "";
        }

        dispatch(setNombreTerapeuta(nombres));

        if (terapeuta) {
            fetchResults(id);
        }
    }
    // const fetchTiposTerapias = async () => {
    //     await api
    //         .get('/Catalogo/GetCatalogosByIdPadreInLista?'
    //         + 'idPadre=49'
    //         )
    //         .then((response) => {
    //             dispatch(setListTiposTerapias(response.data.data));
    //         })
    //         .catch((err) => {
    //             console.log("Err: ", err)
    //         });
    // }
    // const fetchEstados = async () => {
    //     await api
    //         .get('/Catalogo/GetCatalogosByIdPadreInLista?'
    //         + 'idPadre=1'
    //         )
    //         .then((response) => {
    //             dispatch(setListEstados(response.data.data));
    //             dispatch(setValue({name: "idEstado", value: 2}))
    //         })
    //         .catch((err) => {
    //             console.log("Err: ", err)
    //         });
    // }
    // const annulTerapiaPeriodo = async () => {
    //     await api
    //         .post("/Terapia/AnnulTerapiaPeriodo?idTerapiaPeriodo=" + selectId)
    //         .catch((err) => {
    //             console.log("Err: ", err);
    //         });
    //         fetchResults();
    // }
    // const activeTerapiaPeriodo = async () => {
    //     await api
    //         .post("/Terapia/ActiveTerapiaPeriodo?idTerapiaPeriodo=" + selectId)
    //         .catch((err) => {
    //             console.log("Err: ", err);
    //         });
    //         fetchResults();
    // }

    useEffect(() => {
        fetchPeriodos();
        resolverIdTerapeuta();
        // fetchTiposTerapias();
        // fetchEstados();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'codigoServicio', headerName: 'Servicio', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'codigoFilial', headerName: 'Filial', width: 70, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'participante', headerName: 'Participante', width: 180, sortable: true, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/session/edit/0/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'terapeuta', headerName: 'Terapeuta', width: 200, sortable: true, headerAlign: 'center' },
        { field: 'estadoApertura', headerName: 'Apertura', width: 80, sortable: true, headerAlign: 'center', align: 'center' },
        // La ultima sesion registrada del periodo, este o no validado: dice si
        // el periodo esta en uso. La fecha y la hora vienen en texto ISO.
        { field: 'ultimaSesion', headerName: 'Fec. Ult. Sesion', width: 150, sortable: false, headerAlign: 'center', align: 'center'
            , valueFormatter: (value) => (value && moment(value).isValid() ? moment(value).format("DD/MM/YYYY HH:mm") : "")
        },
        // { field: 'codigoTarifa', headerName: 'Tarifa', width: 80, sortable: false, headerAlign: 'center', align: 'center' },
        // { field: 'salon', headerName: 'Salon', width: 100, sortable: true, headerAlign: 'center' },
        // { field: 'fechaInicio', headerName: 'Inicio', width: 120, type: 'date'
        //     , valueFormatter: (value) => moment(value).format('DD/MM/YYYY')
        //     , sortable: true, headerAlign: 'center', align: 'center' },
        // { field: 'estado', headerName: 'Estado', width: 80, sortable: true, headerAlign: 'center', align: 'center' },
        // { field: 'anular', headerName: '', width: 80, sortable: true, headerAlign: 'center', align: 'center'
        //     , renderCell: (cellValues) => {
        //         return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} onClick={() => {
        //             setSelectId(cellValues.row.id);
        //             setSelectState(cellValues.row.estado);
        //             setOpenDialogAnnulActive(true);
        //         }}>
        //             { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
        //         </IconButton>; 
        //     }
        // },
    ];

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {nombreTerapeuta || (esTerapeuta === false ? "No es un terapeuta" : "Cargando...")}
                    </Typography>
                </Grid>
                {!esTerapeuta && idTerapeuta > 0 && (
                    <Grid item xs={12}>
                        <Typography variant="body1" color="warning.main" sx={{ pt: 2 }}>
                            Este usuario no está registrado como terapeuta. Solo los terapeutas pueden ver sus sesiones asignadas.
                        </Typography>
                    </Grid>
                )}
                {esTerapeuta && (
                    <Grid item xs={12}>
                        <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                            <Grid item xs={12} sm={12}>
                                <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                                    <Grid item xs={6} sm={2}>
                                        <FormControl fullWidth>
                                            <InputLabel htmlFor="input-periodo" shrink>Periodo</InputLabel>
                                            <Select
                                                native
                                                label="Periodo"
                                                value={filters.idPeriodo}
                                                onChange={(event) => {
                                                    dispatch(setValue({name: "idPeriodo", value: event.target.value}))
                                                }}
                                                onKeyDown={(event) => {
                                                    if (event.key === "Enter") {
                                                        event.preventDefault();
                                                        fetchResults(idTerapeuta);
                                                    }
                                                }}
                                                inputProps={{
                                                    name: 'idPeriodo',
                                                    id: 'input-periodo',
                                                }}
                                                size="small"
                                            >
                                                <option key={0} value={0}>{"(Todos)"}</option>
                                                {listPeriodos.map((row) => (
                                                    <option key={row.id} value={row.id}>{row.codigo}</option>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={8} sm={2}>
                                        <TextField
                                            // required
                                            name="participante"
                                            label="Participante"
                                            value={filters.participante}
                                            fullWidth
                                            onChange={(event) => {
                                                dispatch(setValue({name: "participante", value: event.target.value}))
                                            }}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    fetchResults(idTerapeuta);
                                                }
                                            }}
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                        <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                            fetchResults(idTerapeuta)
                                        }}>
                                            {<Hidden smDown></Hidden>}
                                            <IconSearch />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                                    <DataGridBase
                                        rows={results}
                                        columns={columns}
                                        loading={cargando}
                                        // hideNewButton={false}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
export default IndexTherapist